import { Controller } from 'stimulus';

export default class extends Controller {
  pollingInterval = 15000;

  connect() {
    const checkNumber = () => {
      this._fetchProvisionStatus().then((data) =>
        (data === null || data.active ? setTimeout(checkNumber, this.pollingInterval) : window.location.reload()));
    };

    checkNumber();
  }

  get opid() {
    return this.element.dataset.opid;
  }

  updateStatus() {
    return fetch(`/opportunities/${this.opid}/update_to_followup`, {
      method: 'POST',
      keepalive: true,
      headers: {
        'X-CSRF-Token': document.querySelector('meta[name=csrf-token]').content,
      },
    });
  }

  /**
   * Fetches provisioned phone number status. If the response is not JSON, return null.
   * @returns {(object|null)} provisioned phone number status object
   */
  async _fetchProvisionStatus() {
    try {
      const response = await fetch(`/opportunities/${this.opid}/phone_number_forwarding/check`);
      return await response.json();
    } catch {
      return null;
    }
  }
}
